import { JetSpecsConfig } from '@/types/jetDetails.types';
import styles from './jetDetails.module.scss';
import Image from 'next/image';

const JetSpecs = ({ citationConfig }: { citationConfig: JetSpecsConfig }) => {
  return (
    <section className="container">
      <div className={styles.jetDetails}>
        <h2 className={styles.jetDetailsTitle}>Technical Specifications</h2>
        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Exterior</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.Exterior.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Range</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.Range.map((item) =>
              item.id === 2 ? (
                <div key={item.id} className={styles.jetDetailsLine}>
                  <Image
                    src={'img/details/check-circled.svg'}
                    alt={item.title}
                    width={24}
                    height={24}
                  />
                  <div className={styles.jetDetailsLineTitle}>
                    <span className={styles.jetDetailsLineValue}>
                      {item.title} {item.value}
                    </span>
                  </div>
                </div>
              ) : (
                <div key={item.id} className={styles.jetDetailsLine}>
                  <Image
                    src={'img/details/check-circled.svg'}
                    alt={item.title}
                    width={24}
                    height={24}
                  />
                  <div className={styles.jetDetailsLineTitle}>
                    {item.title}{' '}
                    <span className={styles.jetDetailsLineValue}>
                      {item.value}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Speed</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.Speed.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Engines</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.Engines.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>
            Airfield Performance
          </div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.AirfieldPerformance.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Avionics</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.Avionics.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>
            Operating Altitude
          </div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.OperatingAltitude.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JetSpecs;
